import React from "react";
import trustPilot from "../../assets/logo/trustpilot.png";
import Spinner from "./Spinner";

const CompanyBlog = ({ video, text, isLoading }) => {
  return (
    <div>
      {isLoading ? (
        <Spinner />
      ) : (
        <>
          {/* <section className="bd-service-area  ">
                        <div className="container" style={{ maxWidth: "1270px" }}>
                            <div className="row">
                                {video.slice(0, 2).map((content) => {
                                    return (
                                        <div className="col-lg-4 col-md-6 first-resp-section mt-80" >
                                            <div className="bd-service" style={{ backgroundColor: "var(--clr-bg-gray)", paddingRight: "17px", paddingLeft: "18px", paddingTop: "13px", paddingBottom: "14px" }}>
                                                <div className="testimonial_video">
                                                    <iframe src={content.video_link} className="resp-videos" allowFullScreen="allowFullScreen" frameBorder="0" width="576" height="300" title="Everytime You Go Away - Paul Young" />
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </section> */}

          <section className="bd-service-area">
            <div className="container" style={{ maxWidth: "1270px" }}>
              <div className="row">
                <div
                  className="col-lg-4 col-md-6 mt-80"
                  style={{ width: "100%" }}
                >
                  <div
                    className="bd-service mb-30 responsive-main_testimonial "
                    style={{
                      backgroundColor: "var(--clr-bg-gray)",
                      height: "100%",
                    }}
                  >
                    <div className="comments-box box-responsive">
                      <div
                        className="comments-avatar mr-40 test-first-section1"
                        style={{ width: "40%" }}
                      >
                        {/* <img src={content.company_logo} className="img-fluid mb-20" style={{ width: "100px" }} alt="img" /> */}
                        <p
                          style={{
                            marginBottom: "0px",
                            color: "black",
                            fontWeight: "570",
                          }}
                        >
                          Tonya L. Horning
                        </p>
                        <p
                          style={{
                            textAlign: "center",
                            width: "100%",
                            marginBottom: "0px",
                          }}
                        >
                          Professional Photographer
                        </p>
                        <p className="mb-20">Tonya Photography</p>
                      </div>
                      <div
                        className="comments-text pb-0 mb-0"
                        style={{ border: "none", width: "100%" }}
                      >
                        <div className="avatar-name">
                          <h4>Website Development </h4>
                        </div>
                        <p style={{ lineHeight: "1.55", marginBottom: "10px" }}>
                          It’s been a great experience working with Ambrella.
                          Appreciate your excellent support throughout our
                          website development. Looking forward to collaborating
                          on new custom projects soon. Thanks for all your
                          support!
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="bd-service-area">
            <div className="container" style={{ maxWidth: "1270px" }}>
              <div className="row">
                <div
                  className="col-lg-4 col-md-6 mt-80 "
                  style={{ width: "100%" }}
                >
                  <div
                    className="bd-service mb-30 responsive-main_testimonial "
                    style={{
                      backgroundColor: "var(--clr-bg-gray)",
                      height: "100%",
                    }}
                  >
                    <div className="comments-box box-responsive">
                      <div
                        className="comments-avatar mr-40 test-first-section1"
                        style={{ width: "40%" }}
                      >
                        {/* <img src={content.company_logo} className="img-fluid mb-20" style={{ width: "100px" }} alt="img" /> */}
                        <p
                          style={{
                            marginBottom: "0px",
                            color: "black",
                            fontWeight: "570",
                          }}
                        >
                          Rick D. Ulrey
                        </p>
                        <p
                          style={{
                            textAlign: "center",
                            width: "100%",
                            marginBottom: "0px",
                          }}
                        >
                          Founder
                        </p>
                        <p className="mb-20">Dynamic Solutions</p>
                      </div>
                      <div
                        className="comments-text pb-0 mb-0"
                        style={{ border: "none", width: "100%" }}
                      >
                        <div className="avatar-name">
                          <h4>E-Commerce </h4>
                        </div>
                        <p style={{ lineHeight: "1.55", marginBottom: "10px" }}>
                          The go-to place for all your IT needs your one-stop
                          solution for web design, marketing, SEO, and app
                          development. Get fresh, creative ideas for your
                          business, backed by a dedicated and hardworking team.
                          A calm workspace with a visionary founder leading the
                          way.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="bd-service-area">
            <div className="container" style={{ maxWidth: "1270px" }}>
              <div className="row">
                <div
                  className="col-lg-4 col-md-6 mt-80 mb-80 "
                  style={{ width: "100%" }}
                >
                  <div
                    className="bd-service mb-30 responsive-main_testimonial "
                    style={{
                      backgroundColor: "var(--clr-bg-gray)",
                      height: "100%",
                    }}
                  >
                    <div className="comments-box box-responsive">
                      <div
                        className="comments-avatar mr-40 test-first-section1"
                        style={{ width: "40%" }}
                      >
                        {/* <img src={content.company_logo} className="img-fluid mb-20" style={{ width: "100px" }} alt="img" /> */}
                        <p
                          style={{
                            marginBottom: "0px",
                            color: "black",
                            fontWeight: "570",
                          }}
                        >
                          Gerald C. Walker
                        </p>
                        <p
                          style={{
                            textAlign: "center",
                            width: "100%",
                            marginBottom: "0px",
                          }}
                        >
                          CEO
                        </p>
                        <p className="mb-20">Walker Technology</p>
                      </div>
                      <div
                        className="comments-text pb-0 mb-0"
                        style={{ border: "none", width: "100%" }}
                      >
                        <div className="avatar-name">
                          <h4>Website Development </h4>
                        </div>
                        <p style={{ lineHeight: "1.55", marginBottom: "10px" }}>
                          A professional, reliable, and friendly company to work
                          with. The project was completed smoothly without any
                          hassle, and the team was always available to help
                          anytime. I’d highly recommend them to anyone looking
                          to use Ambrella. Definitely looking
                          forward to working with them again!
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* <section className="bd-service-area">
                        <div className="container" style={{ maxWidth: "1270px" }}>
                            <div className="row">
                                {video.slice(2).map((content) => {
                                    return (
                                        <div className="col-lg-4 col-md-6 first-resp-section mt-80" >
                                            <div className="bd-service" style={{ backgroundColor: "var(--clr-bg-gray)", paddingRight: "17px", paddingLeft: "18px", paddingTop: "13px", paddingBottom: "14px" }}>
                                                <div className="testimonial_video">
                                                    <iframe src={content.video_link} className="resp-videos" allowFullScreen="allowFullScreen" frameBorder="0" width="576" height="300" title="Everytime You Go Away - Paul Young" />
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </section> */}
        </>
      )}
    </div>
  );
};

export default CompanyBlog;
